import utils from './utils';

const URL = `${BASE_API_URL}/helpdesk`;

export default {
    getTicketList: data => utils.get(`${URL}/tickets/`, data),
    getTicketDetail: id => utils.get(`${URL}/tickets/${id}/`),
    updateTicketDetail: (id, data) =>
        utils.patch(`${URL}/tickets/${id}/`, data),
    createTicket: data => utils.post(`${URL}/tickets/`, data),
    getStateList: () => utils.get(`${URL}/states/`),
    getProjectList: () => utils.get(`${URL}/projects/`),
    getAssigneeList: () => utils.get(`${URL}/assignees/`),
    getCommentList: id => utils.get(`${URL}/tickets/${id}/comments/`),
    sendComment: (ticketId, data) =>
        utils.post(`${URL}/tickets/${ticketId}/comments/`, data),
    createAttachment: data =>
        utils.post(`${URL}/attachments/`, data, 'multipart/form-data'),
};



// WEBPACK FOOTER //
// ./src/api/helpdesk.js